<template>
	<div class="o-container o-container--thin registration-page">
    <form
      :class="[
        'styled-form',
        'styled-form--white-box',
        {'is-loading': isLoading}
      ]"
      @submit.prevent="onSubmit"
      autocomplete="off"
    >
      <div class="text--center top-gap-15 bottom-gap-15 offer-shirt">
        <img src="images/offers/fan_offer_tile.png" alt="offer-shirt">
      </div>
      <div class="o-grid--no-hgutter">
        <div class="o-grid--no-hgutter o-grid__item">
          <h1 class="common__heading m-auto">
            WIN
          </h1>
        </div>
      </div>
      <div class="o-grid--no-hgutter">
        <div class="o-grid__item">
          <div class="fanoffer-preferences-view__item m-auto">
            Sign in or create a Football Account and you go in the draw to win your very own signed CommBank Matildas or Socceroos jersey.
          </div>
        </div>
      </div>
      <div class="o-grid--no-hgutter">
        <div class="o-grid__item">
          <div class="common__sub-heading fanoffer-preferences-view__item m-auto">
            Terms and Conditions
            <a href = "https://www.footballaustralia.com.au/sites/ffa/files/2021-12/21-1214%20-%20Create%20a%20Football%20Account%20Competition_Terms%20and%20Conditions_.pdf" target="new" class="styled-form__link"> CLICK HERE </a>
          </div>
        </div>
      </div>
      <div class="o-grid--no-hgutter">
        <div class="o-grid__item">
          <div class="fanoffer-preferences-view__item o-fit-content m-auto text--center" v-if="alreadySubscribed">
            <checkbox
                :checkbox="checkbox"
                class="not-clickable"
                :showDescription="false"
            ></checkbox>
          </div>
          <div class="text--center" v-else>
            <button class="btn" :disabled="isLoading">ENTER</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import Checkbox from '../formFields/Checkbox.vue';

	export default {
    components: {
      Checkbox
    },
    data() {
      return {
        data: {
          optin: true
        },
        isLoading: false,
        checkbox: {
          isChecked: true,
          txt: 'Entered'
        },
        alreadySubscribed: false
      }
    },
    mounted() {
      console.info("START_calling_user.GET_OPTIN_OFFERS");
      console.time("TIME_calling_user.GET_OPTIN_OFFERS");
      return this.$store.dispatch('onboarding/GET_OPTIN_OFFERS').then((fanOffers) => {
        console.timeEnd("TIME_calling_user.GET_OPTIN_OFFERS");

        this.alreadySubscribed = !!fanOffers?.data?.offers?.length

        this.data.optin = JSON.parse(!!this.$route.query?.signedshirt) || JSON.parse(!!this.$route.query?.signed_shirt)
      });
    },
    methods: {
      onSubmit() {
        this.isLoading = true;
        this.submit(this.data).catch(errors => {
          this.isLoading = false;
          if (errors.hasOwnProperty('login')) {
            // redirect to the login page
            this.$router.push({
              name: 'login',
              params: {
                issue: errors.login
              }
            });
          } else {
            this.errors = errors;
          }
        });
      },
      submit(optInData) {
        console.info("START_calling_user.OPTIN");
        console.time("TIME_calling_user.OPTIN");
        return this.$store.dispatch('onboarding/OPTIN', optInData).then((userData) => {
          console.timeEnd("TIME_calling_user.OPTIN");

          if (!userData) {
            this.$store.commit('onboarding/OPT_IN_FAN_OFFER', true);
            localStorage.setItem('optInFanOffer', true);

            // redirect to the login page
            this.$router.push({
              name: 'login'
            });
          } else {
            this.$router.push({
              name: 'myAccount'
            });
          }
        });
      }
    }
  }
</script>

<style scoped>

.offer-shirt img {
  width: -webkit-fill-available;
  height: auto;
}

</style>